import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  gap: 4px;
  background-color: rgba(0, 0, 0, 0.15);
  padding: 4px;
  border-radius: 9999px;
  width: fit-content;
`;

export const Tab = styled.div`
  display: grid;
  place-content: center;
  border-radius: 9999px;
  color: ${({ isActive, textColor }) => (isActive ? textColor : "#3B3B3B")};
  padding: 14px;
  height: 36px;
  box-sizing: border-box;
  background-color: ${({ isActive, accentColor }) =>
    isActive ? accentColor : "transparent"};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
`;
